import { pickBy, identity } from "lodash"

class ListChannelsRequest {

    constructor({
        sort, 
        page,
        search,
        perPage,
        tagIds,
        types,
        communityId,
    }) {
        this.page = page
        this.sort = sort
        this.search = search
        this.perPage = perPage
        this.tagIds = tagIds
        this.types = types
        this.communityId = communityId
    }


    getPayload = () => {
        
        let payload = {
            "page": this.page,
            "sort": this.sort,
            "search": this.search,
            "per_page": this.perPage.value,
            "tag_ids": [].concat(this.tagIds).join(","),
            "filter_by_type": [].concat(this.types).join(","),
            "community_id": this.communityId,
        }

        return pickBy(payload, identity)
    }
    
}

export default ListChannelsRequest